import React from 'react';
import webapi from '../../../api/webapi';
import Header from '../Header/Header';
import Loading from '../modal/Loading';
import Footer from '../Footer/Footer';
import RelativeSearchBox from './RelativeSearchBox';

class Relative extends React.Component {
    state = {LoadingShow : false}
    state = { LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}] }

    componentDidMount(){
        if (new URLSearchParams(this.props.location.search).get("lang")!=null)
        {
            //console.log('LangFromURL: ',new URLSearchParams(this.props.location.search).get("lang"));
            //console.log('LangFromSubDomain: ',window.location.host.split(".")[0]);
            this.getLanguageInfo(new URLSearchParams(this.props.location.search).get("lang"));
            //console.log(this.state.LanguageInfo);
        }else{
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
            this.getPage();
        }

        //fetch('https://api.ipify.org/?format=json')
        fetch('https://geolocation-db.com/json/')
        .then(response => {
            return response.json();
        }, "jsonp")
        .then(res => {
            this.setLog('pages/log/Relative/visit/'+res.IPv4.replaceAll('.',','))
        })
        .catch(err => this.setLog('pages/log/Relative/visit/'+err));
        
    }

    async setLog(Data) {
        await webapi.post(Data);
    }

    async getLanguageInfo(LanguageCode){
        const responseResultlanguageinfo = await webapi.get('pages/LanguageInfo/'+LanguageCode);
        //console.log(responseResultlanguageinfo.data.length);
        //console.log(responseResultlanguageinfo.data);
        
        if (responseResultlanguageinfo!==undefined && responseResultlanguageinfo.data.length>0)
        {
            this.setState({LanguageInfo:responseResultlanguageinfo.data});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang", responseResultlanguageinfo.data[0].Code);
            document.getElementsByTagName('html')[0].setAttribute("dir", responseResultlanguageinfo.data[0].Direction);
        }
        else
        {
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang","fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
        }
        this.getPage();
    }

    async getPage() {
        if (this.state.LanguageInfo)
        {
            const pageList = await webapi.get('pages/datapages/204/'+this.state.LanguageInfo[0].Code);
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }else{
            const pageList = await webapi.get('pages/datapages/204/fa');
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }
    }

    render() {
        if (this.state.pageData && this.state.LanguageInfo) {
            return (
                    <div>
                        <Header LanguageInfo = {this.state.LanguageInfo}/>
                            <div className="container-fluid" id="innerpage_row_1">
                                <div className="container">
                                <h1 id="page_title">{this.state.pageData.length!==0 && this.state.pageData[0].F204!== undefined?this.state.pageData[0].F204:204/*با هم آیی*/}</h1>
                                <h2 id="page_title_dek">{this.state.pageData.length!==0 && this.state.pageData[0].F20400!== undefined?this.state.pageData[0].F20400:20400/*بررسی با هم آیی کلمات در متون*/}</h2>
                                <hr className="halfwidth" />
                                </div>
                            </div>
                        <Loading LoadingShow={this.state.LoadingShow} />
                        <RelativeSearchBox  pageData={this.state.pageData}
                                            Lang = {this.state.LanguageInfo[0].Code}
                        />                
                        <Footer Lang = {this.state.LanguageInfo[0].Code}/>
                    </div>   
            )
        }
        else
        {
            return (
                <div></div>
            )
        }
    }
 }

 export default Relative;